import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { Observable, Observer } from 'rxjs';
import { Cells } from '../models/utils/cells.model';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor() {}

  importTo(file: any, column: any[]): Observable<any> {
    var reader = new FileReader();
    return new Observable((obs: Observer<any[]>) => {
      reader.readAsArrayBuffer(file);
      reader.onload = (event) => {
        let fileBuffer = reader.result;
        const workbook = XLSX.read(fileBuffer, {});
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        var worksheetNameList = workbook.SheetNames;
        let columnHeaders = [];
        for (
          var sheetIndex = 0;
          sheetIndex < worksheetNameList.length;
          sheetIndex++
        ) {
          var workSheet = workbook.Sheets[worksheetNameList[sheetIndex]];
          for (let key in workSheet) {
            let regEx = new RegExp('^(\\w)(1){1}$');
            if (regEx.test(key) == true) {
              columnHeaders.push(workSheet[key].v);
            }
          }
        }
        const columns = this.getKeyColumns(column, columnHeaders);
        const jsonArray = XLSX.utils.sheet_to_json(worksheet, {
          range: 1,
          raw: true,
          header: columns,
          defval: '',
        });
        obs.next(jsonArray);
        obs.complete();
      };
      reader.onerror = () => {
        const { name } = file;
        obs.error({
          error: { name, errorMessage: 'Ocorreu um erro na importação!' },
        });
      };
    });
  }

  exportTo(
    value: any,
    column: any[],
    sheetName: string,
    fmt: string,
    comments: Cells[] | null = null
  ) {
    const stringify = JSON.stringify(value);
    const data = JSON.parse(stringify);
    const columns = this.getColumns(column);

    const worksheet = XLSX.utils.json_to_sheet(data);

    /* fix headers */
    XLSX.utils.sheet_add_aoa(worksheet, [columns], { origin: 'A1' });

    /* calculate column width */
    worksheet['!cols'] = this.fitToColumn(data, columns);

    if (comments) {
      comments.forEach((c: Cells) => {
        /* get cell A1, creating an empty cell if necessary */
        var cell = worksheet[c.cell];
        if (!worksheet[c.cell]) worksheet[c.cell] = { t: c.t };

        /* create comment array if it does not exist */
        if (!cell.c) cell.c = [];

        /* create a comment part */
        var comment_part = {
          a: c.a,
          t: c.t,
        };

        /* Add comment part to the comment array */
        cell.c.push(comment_part);
      });
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(
      workbook,
      `export-beneficiarios-${moment().format('YYYYMMDDhhmmss')}.${fmt}`
    );
  }

  private fitToColumn(data: any, columns:any) {
    let objectMaxLength: any[] = [];
    for (let i = 0; i < data.length; i++) {
      let value = <any>Object.values(data[i]);
      for (let j = 0; j < value.length; j++) {
        if (value[j]) {
          objectMaxLength[j] =
            objectMaxLength[j] >= value[j].length
              ? Math.max(objectMaxLength[j])
              : columns[j].length >= value[j].length
              ? Math.max(columns[j].length + 1) : Math.max(value[j].length + 1);
        }
      }
    }
    return objectMaxLength.map((m) => ({ wch: m }));
  }

  private getColumns(data: any[]): string[] {
    const columns: any[] = [];
    data.forEach((col) => {
      if (!columns.includes(col.value)) {
        columns.push(col.value);
      }
    });
    return columns;
  }

  private getKeyColumns(data: any[], ref: any[]): string[] {
    const columns: any[] = [];
    ref.forEach((col) => {
      const index = data.findIndex((f) => f.value === col);
      if (index >= 0 && !columns.includes(data[index].key)) {
        columns.push(data[index].key);
      }
    });
    return columns;
  }
}
